import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getUserObjectMatches = ({ version = 'v1', params }) =>
  client
    .request({
      url: `${version}/object-match/user-object-matches/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);

export const updateUserObjectMatch = ({ version = 'v1', id, payload }) =>
  client
    .request({
      url: `${version}/object-match/user-object-matches/${id}/`,
      method: RequestMethod.PATCH,
      data: payload,
    })
    .then(handleJSONResponse)
    .catch(handleError);
